import type { ReactNode } from "react";
import type { NodeTypes } from "@xyflow/react";
import { SiteFrameNode, HeroConceptNode, StockCandidateNode, GalleryBoxNode, WireframeNode, TeardownNode } from "./media";
import { TitleNode, SectionTitleNode, StratCardNode, PainCardNode, MapCard, PageSpecNode, CompMatrixNode, SectionNode } from "./cards";
import { TimelineNode, ProcessStripNode, IntakeCardNode, RevenueModelNode } from "./strategy";
import { LogoCategoryNode, IconGalleryNode } from "./icons";
import { ArticleShotNode, ArticleColHeaderNode } from "./articles";
import { AnalysisCardNode } from "./analysis";

export const SLIDE_COMPONENTS: Record<string, (p: { data: any }) => ReactNode> = {
  stratCard: StratCardNode,
  compMatrix: CompMatrixNode,
  painCard: PainCardNode,
  pageSpec: PageSpecNode,
  timeline: TimelineNode,
  revenueModel: RevenueModelNode,
  intakeCard: IntakeCardNode,
};

export const nodeTypes: NodeTypes = { siteFrame: SiteFrameNode, title: TitleNode, heroConcept: HeroConceptNode, stockCandidate: StockCandidateNode, sectionTitle: SectionTitleNode, galleryBox: GalleryBoxNode, logoCategory: LogoCategoryNode, stratCard: StratCardNode, timeline: TimelineNode, processStrip: ProcessStripNode, intakeCard: IntakeCardNode, revenueModel: RevenueModelNode, painCard: PainCardNode, mapCard: MapCard, pageSpec: PageSpecNode, compMatrix: CompMatrixNode, section: SectionNode, wireframe: WireframeNode, teardown: TeardownNode, iconGallery: IconGalleryNode, articleShot: ArticleShotNode, articleColHeader: ArticleColHeaderNode, analysisCard: AnalysisCardNode };

